import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getRentalHouseId = (facilityId) =>
  typeof facilityId === 'string' ? Number(facilityId) : facilityId;

export const getCompanyServices = async (facilityId) => {
  return await request.get(
    `/RentPlace/company_service`,
    { rentalHouseId: facilityId },
    'При загрузке услуг произошла ошибка'
  );
};

const useCompanyServices = (facilityId, options) => {
  const rentalHouseId = getRentalHouseId(facilityId);

  return useQuery(
    [queries.companyServices, rentalHouseId],
    () => getCompanyServices(rentalHouseId),
    options
  );
};

export default useCompanyServices;
